export function changeButtonState($formFields, $submitBtn) {
    let invalidFields = 0;
    $formFields.each((index, elem) =>  {
        if (!$(elem).val().length) {
            invalidFields++;
        }
    });
    let isInvalid = invalidFields > 0;
    $submitBtn.attr("disabled", isInvalid);

    if (isInvalid) {
        $submitBtn.addClass("disabled");
    } else {
        $submitBtn.removeClass("disabled");
    }
}

export function checkoutChangeButtonState() {
    let $form = $(".single-shipping .shipping-form");
    let $submitBtn = $(".submit-shipping");

    $form.each((index, item) => {
        let $formFields = $(item).find(".form-control[required]");
        changeButtonState($formFields, $submitBtn);

        $formFields.on("keyup change", function () {
            changeButtonState($formFields, $submitBtn);
        });
    });
}


